export class HisSearchConstants {

    public static readonly SEARCH_CONFIG_FILE = 'configFile';
    public static readonly GROUPS = 'groups';
    public static readonly GROUP_LABEL = 'label';
    public static readonly CRITERIA_GROUP_AND = 'and';
    public static readonly CRITERIA = 'criteria';
    public static readonly FIELD = 'field';
    public static readonly NOT = 'not';
    public static readonly OPERATOR = 'operator';
    public static readonly VALUE = 'value';
    public static readonly CRITERIA_GROUPS = 'criteriaGroups';
    public static readonly EXCLUDING = 'excluding';
    public static readonly FILTER = 'filter';

}
